

exports.__esModule = true;
exports.$xoReviewPageComponent = undefined;

var _squid = require('squid');

var _jquery = require('jquery');

var _jquery2 = _interopRequireDefault(_jquery);

require('js/lib/index');

require('xo-models/src/checkout/index');

require('xo-title/dist/directive');

require('xo-ui-components/src/message/directive');

require('xo-form-components/src/select-shipping-method/directive');

require('xo-member-components/src/review-address/directive');

require('xo-member-components/src/review-paywith/directive');

require('xo-page-components/src/value-props/directive');

require('xo-address-components/src/address-display/directive');

require('xo-credit-components/src/offer/directive');

require('xo-return-to-merchant/dist/util');

require('xo-models/src/bml/index');

require('xo-models/src/fi/index');

require('xo-models/src/fi/lib/fiMessages');

require('xo-models/src/fi/lib/fiApis');

require('xo-device-info/dist/index');

require('xo-beaver/dist/logger');

require('xo-credit-components/src/bml-display/xo-bml-popup/directive');

require('xo-page-components/src/done/directive');

require('xo-page-components/src/cart/lib/pxp');

require('xo-wallet-components/src/3ds/directive');

require('xo-models/src/profilemanagement/index');

require('xo-models/src/inventory/index');

var _template = require('./template');

var _template2 = _interopRequireDefault(_template);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var $xoReviewPageComponent = exports.$xoReviewPageComponent = _squid.$Component.extend('$xoReviewPageComponent', {
    tag: 'xo-review-page',
    template: _template2['default'],
    scope: {},
    lifecycle: {
        reenter: function reenter() {
            var msgKeys = this.checkoutSession.get('message.msgKeys', []);

            if (msgKeys.indexOf('confirmUpop.confirmUpopOrChooseAltMethod') === -1) {
                this.showUnconfirmedUpopMsg = !!this.checkoutSession.unconfirmed_upop;
            }
        }
    },
    controller: function controller($scope, $state, $rootScope, $FallbackError, $populate, $DeviceInfo, $logger, $CheckoutAppDataModel, $CheckoutCartModel, $CheckoutSessionModel, $ShippingRuleSummaryModel, $feature, $AuthModel, $pxp, $config, $meta, $experiment, $miniBrowser, $locale, $pxpFactors, $window, $util, $featureCountries, $BMLModel, $ApplyForBMLModel, $q, $CheckoutPayeeModel, $pxpCartAmt, $timeout, $unresolved, $BuyerEligibilityModel, $renderContent, $fiMessages, $fiApis, $element, $MerchantPreferenceModel, $AddCardModel, $CardModel, $CreditInstallmentModel, $InventoryModel, $CreditDataModel) {

        $logger.info('buyer_info', {
            fpti_buyer_type: 'Existinguser'
        });

        var showButtonPxp = false;
        // show fixed button for mobile and incontext view
        var allowFixedButton = $DeviceInfo.isMobile() || $miniBrowser.isMiniBrowser();

        $scope.token = $rootScope.token;

        $scope.backUri = 'checkout.review';

        $scope.installmentNotSelected = false;

        $scope.installment = {
            showBanner: false,
            showCYCO: false
        };

        // 'continue' or 'pay now' button text
        $scope.payButtonText = function () {
            return '';
        };

        $scope.isGCcountry = ($config.giftCardSupportedCountries || '').indexOf($locale.country) > -1;

        $scope.showPaypalPolicies = $featureCountries('showPaypalPolicies').indexOf($locale.country) > -1;

        $scope.makeAddrPreferred = {
            shown: false,
            selected: false
        };

        $scope.showPolicyAgreement = $feature('showPolicyAgreement');

        $scope.locale = $locale;

        // Format the informal name if populated
        function setInformalName() {
            if ($scope.auth) {
                $scope.formattedNameInformal = (0, _squid.formatNameInformal)({
                    first_name: $scope.auth.first_name,
                    last_name: $scope.auth.last_name
                }) || $scope.auth.email;
            }
        }

        function updateAddressAsPreferred() {
            if ($scope.makeAddrPreferred.shown) {
                $logger.info('makeAddrPreferred.shown', {});
            }

            if ($scope.makeAddrPreferred.selected) {
                $logger.info('makeAddrPreferred.selected', {});

                // Ignore all errors from setPreferred api, by passing transientError as true
                return $scope.checkoutSession.shipping.action('setPreferred', {
                    transientError: true
                });
            }

            return $q.when();
        }

        function updateEmailBuyerOptin(appData, consent) {
            // do not patch data if the buyer cannot choose opt-in
            return appData.flags.display_buyer_email_promotional_opt_in ? appData.action('updateBuyerEmailOptin', {
                data: {
                    buyerConsented: consent
                },
                transientError: true
            }) : $q.when();
        }

        function setStickyInstrument() {
            if (!$config.features.DEFAULT.enableStickyFunding) {
                return $q.when();
            }

            var stickyInstrument = $scope.checkoutSession.selectedFuturePaymentInstrument ? undefined : $scope.checkoutSession.getSelectedStickyInstrument();

            if (stickyInstrument) {
                return $scope.checkoutSession.action('setStickyFI', {
                    data: {
                        instrument_id: stickyInstrument.instrument_id
                    }
                });
            }

            return $q.when();
        }

        function show3DSLightbox() {
            $scope.resolve_3ds_data = {
                cc_id: $scope.checkoutSession.get('resolve_3ds.ccId'),
                flow_id: 'HERMES',
                merchant_id: $scope.payee.get('merchant.id'),
                merchant_country_code: $scope.checkoutAppData.get('merchant.merchant_country'),
                transaction_amount_currency: $scope.checkoutCart.get('purchase.amounts.total.currency_code'),
                transaction_amount_value: $scope.checkoutCart.get('purchase.amounts.total.amount')
            };
            $scope.launch3DSResolver = true;
        }

        function showGenericError(code) {
            return function () {
                var encoded = code ? window.btoa(code) : code;
                return $state.go('checkout.genericError', {
                    code: encoded
                });
            };
        }

        function getMerchantPreferences() {

            return $populate($scope, {
                pref: $MerchantPreferenceModel.instance($scope.payee.merchant.id)
            });
        }

        function setProcessorDeclineMessage() {

            var processorDeclinedMsg = $fiMessages.processorDeclinedMsg($scope.checkoutSession, true);

            if (processorDeclinedMsg) {
                $scope.checkoutSession.message = {
                    type: processorDeclinedMsg.type,
                    msgs: [processorDeclinedMsg.msg]
                };
            }
        }

        function makePayment() {
            return $scope.checkoutSession.action('createPayment', {
                data: {
                    payer_id: $scope.checkoutSession.payer.id,
                    intent: $scope.checkoutCart.payment_action
                },

                success: function success(result) {
                    $rootScope.paymentComplete = true;
                    $logger.info('wps_cart_to_txn_mapping', {
                        cart_id: $scope.token,
                        txn_id: result.transactionDetails && result.transactionDetails.id,
                        txn_receipt_id: result.transactionDetails && result.transactionDetails.receipt_id
                    });
                    return 'success';
                },

                contingencies: {
                    TRANSACTION_REFUSED: showGenericError('TRANSACTION_REFUSED'),
                    PAYEE_BLOCKED_TRANSACTION: showGenericError('PAYMENT_DENIED'),
                    DUPLICATE_TRANSACTION: showGenericError('PAYMENT_ALREADY_DONE'),
                    CC_PROCESSOR_DECLINED: function CC_PROCESSOR_DECLINED() {
                        return $scope.checkoutSession.action('create', {
                            success: function success(result) {
                                setProcessorDeclineMessage();
                                return $state.go('checkout.review');
                            },
                            contingencies: {
                                DEFAULT: function DEFAULT(name, err) {
                                    throw err;
                                }
                            }

                        });
                    }
                }
            });
        }

        function inventoryOperation() {
            var cartHasInventory = $scope.checkoutCart.get('cartHasInventory');
            if (cartHasInventory) {
                var inventoryModel = $InventoryModel.instance($rootScope.token);
                var inventoryItems = inventoryModel.getInventoryItems();
                var inventoryPatchInput = {
                    inventoryItems: inventoryItems,
                    cartItems: $scope.checkoutCart.get('purchaseUnits')[0].item_list.items,
                    merchantId: $scope.payee.get('merchant.id', '')
                };
                return inventoryModel.action('patchInventory', {
                    data: inventoryPatchInput,
                    success: function success(patchResponse) {
                        if (patchResponse.showSoldoutPage) {
                            // show soldout page
                            return {
                                soldoutpage: true,
                                items: patchResponse.soldoutItems,
                                soldOutUrl: patchResponse.soldoutUrl
                            };
                        } else if (patchResponse.patchCart) {
                            var purchase_unit = $scope.checkoutCart.get('purchaseUnits')[0];
                            purchase_unit.item_list.items = patchResponse.cartItems;
                            var patchCartPayload = {
                                id: $scope.token,
                                patchEntities: [{
                                    field: 'inventoryItems',
                                    value: [purchase_unit.item_list.items[0]]
                                }]
                            };

                            return $scope.checkoutCart.action('patchCartData', {
                                data: patchCartPayload
                            });
                        }
                        return;
                    }
                });
            } else {
                return $q.when(); // not an inventory request proceed with existing flow
            }
        }

        function authorize() {
            if ($scope.checkoutSession.resolve_3ds) {
                return show3DSLightbox();
            }
            if ($scope.checkoutSession.unconfirmed_upop) {
                var card = $scope.checkoutSession.unconfirmed_upop;

                $scope.cardModel = new $AddCardModel({});
                $scope.cardModel.id = card.fundingId;
                $scope.cardModel.card = new $CardModel({
                    number: 'xxxx-xxxx-xxxx-' + card.fi.number,
                    type: card.fi.type.toUpperCase(),
                    productType: card.fi.productType
                });

                $state.go('.confirmUpop');
                return;
            }

            return $scope.checkoutSession.action('authorize', {
                success: function success() {
                    if ($scope.checkoutSession.get('plan.paypal_credit')) {
                        $logger.info('checkout_fpti', {
                            'ppc_reuse_status': 'success'
                        });
                    }
                    if ($scope.checkoutAppData.doec_on_approve()) {
                        return inventoryOperation().then(function (result) {
                            if (result && result.soldoutpage) {
                                return $state.go('checkout.soldout', {
                                    items: encodeURIComponent(result.items),
                                    soldOutUrl: encodeURIComponent(result.soldOutUrl)
                                });
                            }
                            return $q.all([makePayment(), getMerchantPreferences()]).then(function () {
                                if ($rootScope.paymentComplete) {
                                    return $state.go('checkout.done');
                                }
                            });
                        });
                    } else {
                        if ($scope.checkoutSession.sepa_mandate) {
                            return $state.go('checkout.sepapage');
                        }
                        return $state.go('checkout.end');
                    }
                }
            });
        }

        function setShowShippingMethodProperty() {
            return $populate($scope, {
                shippingRulesSummary: $ShippingRuleSummaryModel.instance($rootScope.token).retrieve({
                    params: {
                        merchant_id: $scope.payee.get('merchant.id'),
                        currency_code: $scope.checkoutCart.get('purchase.amounts.total.currency_code')
                    }
                })
            }).then(function () {
                if ($scope.shippingRulesSummary.isSnTEnabled) {
                    $logger.info('shipping_rules_summary_snt_enabled');
                } else {
                    $logger.info('shipping_rules_summary_snt_disabled');
                }
                $scope.showShippingMethod = $scope.shippingRulesSummary.isSnTEnabled;
                return;
            });
        }

        function show3DSDeclineMsg(declineAfter3DSAccept) {
            var key = 'threeDS.memberDecline';

            if (declineAfter3DSAccept) {
                key = 'threeDS.memberDeclineAfter3DSAccept';
            }

            var card = $scope.checkoutSession.resolve_3ds;

            if (card) {
                var msg = $renderContent(key, {
                    cardType: card.type,
                    last4: card.number
                });

                $scope.checkoutSession.message = {
                    msgs: [msg],
                    type: 'warning'
                };
            }
        }

        /**
         * call patchXO API to clear the 3DS contingency and then call authorize API.
         */
        function clear3DSContingency() {
            var resolve_3ds = $scope.checkoutSession.resolve_3ds || {};

            return $scope.checkoutSession.action('clear3DSContingency', {
                data: {
                    ccId: resolve_3ds.ccId
                },
                success: function success(response) {
                    if (!$scope.checkoutSession.resolve_3ds) {
                        return authorize();
                    } else {
                        // Symphony is not able to clear the 3DS contingency
                        show3DSDeclineMsg(true);
                    }
                }
            });
        }

        $scope.onComplete3DSHandler = function (status) {
            $scope.launch3DSResolver = false;
            if (status === 'success') {
                return clear3DSContingency();
            } else if (status === 'decline') {
                // 3DS got declined
                show3DSDeclineMsg();
            }
        };

        $scope.onConfirmUpopSuccess = function () {
            $state.go('checkout.review');
            $scope.checkoutSession.action('clearContingency', {
                data: {
                    contingency: 'UNCONFIRMED_UPOP',
                    ccId: $scope.checkoutSession.unconfirmed_upop.fundingId
                },
                success: function success() {
                    if (!$scope.checkoutSession.unconfirmed_upop) {
                        return authorize();
                    } else {
                        $scope.checkoutSession.message = {
                            type: 'warning',
                            msgKeys: ['confirmUpop.confirmUpopOrChooseAltMethod']
                        };
                    }
                }
            });
        };

        $scope.onConfirmUpopCancel = function () {
            $state.go('checkout.review');
            $scope.showUnconfirmedUpopMsg = false;
            $scope.checkoutSession.message = {
                type: 'warning',
                msgKeys: ['confirmUpop.confirmUpopOrChooseAltMethod']
            };
        };

        $scope.returnFromCape = function (isCapeReturnKey) {
            return $scope.creditDataModel.action('readCreditKey', {
                data: {
                    capeKey: isCapeReturnKey
                },
                success: function success(res) {

                    if (res.financial_instrument_id) {
                        return $scope.checkoutSession.fundingOptions.action('update', {
                            resultModel: $scope.checkoutSession,
                            data: {
                                planId: res.financial_instrument_id
                            },
                            success: function success(result) {
                                // Todo Show success message from CAPE
                            }
                        });
                    }

                    // User does not have any FI in wallet and they choose to pay in full.
                    else if (!$scope.checkoutSession.get('plan.sources') && $scope.checkoutSession.isCreditPromoted) {
                            $state.go('checkout.pageAddCard.addCardFlow.addCard');
                        } else if ($scope.creditDataModel.isCapeInternalServiceError()) {
                            // Todo Show error message from CAPE
                            return $q.when();
                        } else {
                            return $q.when();
                        }
                }
            });
        };

        $populate($scope, {
            auth: $AuthModel.instance(),
            checkoutAppData: $CheckoutAppDataModel.instance($scope.token),
            checkoutCart: $CheckoutCartModel.instance($scope.token),
            checkoutSession: $CheckoutSessionModel.instance($scope.token),
            payee: $CheckoutPayeeModel.instance($scope.token),
            buyerEligibility: $BuyerEligibilityModel.instance($scope.token)
        }).then(function () {

            $scope.logout = function () {
                $logger.info('not_you_logout');
                $scope.auth.action('logout').then(function () {
                    $state.go('checkout.login', {
                        source: 'NOT_YOU'
                    });
                });
            };

            var isCapeReturnKey;
            $scope.creditDataModel = $CreditDataModel.instance($scope.token);
            var isChangeInstallments = $scope.creditDataModel.isChangeStatus();
            isCapeReturnKey = $scope.creditDataModel.getCapeKey();

            if (isChangeInstallments && $scope.creditDataModel && !$scope.creditDataModel.payInFull) {
                $state.go('checkout.chooseCreditOffer');
            }
            if (isCapeReturnKey) {
                $scope.returnFromCape(isCapeReturnKey);
            }

            if ($feature('creditInstallmentOffers') && ($scope.checkoutSession.get('plan.paypal_credit') || isCapeReturnKey)) {
                $scope.creditOptions = $CreditInstallmentModel.instance($scope.token);
                $scope.creditOptions.retrieve();
            }
            // create an initial "container" to hold the opt-in checkbox value.
            // see http://stackoverflow.com/a/23943930 for why a container is needed.
            $scope.optin = {
                email: $scope.checkoutAppData.flags.buyer_consented_for_promotional_email
            };

            $scope.showInstallmentOption = function () {
                return $feature('creditInstallmentOffers') && $scope.checkoutSession.get('plan.paypal_credit') && $scope.creditOptions && $scope.creditOptions.creditType === 'INST' && $scope.checkoutSession.creditOffer;
            };

            if (!$scope.buyerEligibility.eligible) {
                throw new $FallbackError({
                    reason: 'buyer_ineligible',
                    product: 'ux'
                });
            }

            if ($window.location.search.search('atoSuccess') !== -1) {
                $logger.debug('PLANNING_ATO_SUCCESS');
                var atoMsg = $locale.content.get('memberReview.stepupAuthSuccess');

                if (atoMsg) {
                    $scope.checkoutSession.message = {
                        msgs: [atoMsg],
                        type: 'success'
                    };
                }
            }

            $scope.$on('localeChange', setInformalName);
            setInformalName();

            $scope.showNotYou = $scope.auth.is_auth_api_call && $util.param('source') !== 'consumerApp' && !$util.param('redirectToHermesOn3DSDecline');

            if ($util.param('redirectToHermesOn3DSDecline')) {
                // check and show the 3DS decline message when the app is redirected from Xoon app
                show3DSDeclineMsg();
            }

            $scope.showAuthMsg = ['authorize', 'order'].indexOf($scope.checkoutCart.get('payment_action')) > -1 && !$scope.checkoutSession.get('plan.paypal_credit');

            $scope.showUnconfirmedUpopMsg = !!$scope.checkoutSession.unconfirmed_upop;

            $scope.useraction = $scope.checkoutAppData.useraction() && $scope.checkoutAppData.useraction().toLowerCase();

            // Non-AU merchants are subjected to PXP test when user action is not commit and line item details
            // are not available and purchase amount is not zero.
            var noLineItemDetails = $scope.useraction !== 'commit' && $scope.checkoutCart.get('purchase.items.length', 0) === 0;

            if ($scope.checkoutSession.bmlOffer) {
                if (!$rootScope.bml) {
                    $rootScope.bml = new $BMLModel();
                }
                $rootScope.bmlApply = new $ApplyForBMLModel();
            }

            return $pxpCartAmt($scope.checkoutAppData.get('merchant.merchant_country'), $scope.payee.get('merchant.id', ''), noLineItemDetails, $scope.checkoutCart.isPurchase()).then(function (showAmount) {
                $scope.showAmt = showAmount;
            });
        }).then(function () {
            if (allowFixedButton) {
                return $pxp('xo_hermes_fixed_button', {}, 'xo_hermes_fixed_button_test_group').then(function (result) {
                    showButtonPxp = result && result.treatment_name === 'xo_hermes_fixed_button_test_group';
                });
            }
        }).then(function () {
            if (!$miniBrowser.isMiniBrowser() && $locale.country === 'BR') {
                var brPxp = $config.pxpExperiments.BR.xo_br_hermesnode_ryi_design;

                $pxpFactors(brPxp.pgName, brPxp.params, brPxp.pattern).then(function (result) {
                    $scope.ryiDesignExp = result;
                });
            }
        }).then(function () {
            $scope.showShippingMethod = false;
            if ($scope.checkoutAppData.doec_on_approve()) {
                return setShowShippingMethodProperty();
            }
            return $q.when();
        }).then(function () {
            $scope.cancel = $scope.checkoutAppData.urls.cancel_url;

            var isBilling = $scope.checkoutCart.isBilling();
            var isBillingPurchase = $scope.checkoutCart.isBillingPurchase();
            var isWPSFlow = $scope.checkoutAppData.doec_on_approve();
            $scope.merchantMsg = $scope.checkoutCart.getBillingDescription();

            /* -- refined by creating isBilling and isBillingPurchase variables -- */
            $scope.showReviewLater = !$scope.showAmt && (!isBilling || isBillingPurchase);

            // show shipping address based on merchant passed in parameter
            $scope.showShippingAddress = Boolean(!$scope.checkoutAppData.flags.hide_shipping_address && $scope.checkoutAppData.flags.shipping_address_required && $scope.checkoutSession.shipping);

            /* -- end refined -- */

            // review page 'continue' or 'pay now' button logic to return the button text
            $scope.payButtonText = function () {
                if (isBilling) {
                    if ($scope.useraction === 'commit' && isBillingPurchase) {
                        return $locale.content.get('memberReview.agreeAndPayLabel');
                    } else {
                        return $locale.content.get('memberReview.agreeAndContinueLabel');
                    }
                } else if (isWPSFlow || $scope.useraction === 'commit') {
                    if ($scope.checkoutSession.unconfirmed_upop) {
                        return $locale.content.get('memberReview.pay');
                    } else {
                        return $locale.content.get('memberReview.payLabel');
                    }
                } else {
                    return $locale.content.get('memberReview.continueLabel');
                }
            };

            $scope.onRedeemGC = function () {
                throw new $FallbackError({
                    reason: 'redeem_coupon_feature_not_supported',
                    product: 'ux'
                });
            };

            // Check if processor decline message needs to be set
            setProcessorDeclineMessage();

            var isButtonBelowScreen = function isButtonBelowScreen() {
                var $button = $element.find('#button')[0];
                var $windowElement = (0, _jquery2['default'])(window)[0];

                var windowTop = $windowElement.scrollY;
                var windowBottom = windowTop + $windowElement.screen.height;

                var buttonTop = windowTop + $button.getBoundingClientRect().top;
                var buttonBottom = buttonTop + $button.offsetHeight;

                return !(buttonBottom <= windowBottom && buttonTop >= windowTop);
            };

            $scope.showFixedButton = function () {
                return allowFixedButton && showButtonPxp && isButtonBelowScreen();
            };

            $timeout(function () {
                if (!allowFixedButton) {
                    return false;
                }

                if ($scope.showFixedButton()) {
                    $logger.info('button_below_screen', {
                        fpti_fixed_button_pxp: 'test'
                    });
                } else if (isButtonBelowScreen() && !showButtonPxp) {
                    $logger.info('button_below_screen', {
                        fpti_fixed_button_pxp: 'control'
                    });
                }
            }, 500);

            if (allowFixedButton && showButtonPxp) {
                (0, _jquery2['default'])(window).bind('scroll', function () {
                    $scope.$apply();
                });
            }

            $scope.$on('$destroy', function () {
                (0, _jquery2['default'])(window).unbind('scroll');
            });

            $scope.promotion = {
                type: null,
                name: ''
            };

            var plccOffer = $scope.checkoutSession.plccOffer;

            if (plccOffer) {
                $scope.promotion.logoUrl = plccOffer.product_logo;
                $scope.promotion.name = plccOffer.product_name;
            }

            $scope.onPay = function (result) {
                if ($scope.checkoutSession.installments && $scope.checkoutSession.installments.length > 1 && !$scope.checkoutSession.selectedInstallmentData) {
                    $scope.installmentNotSelected = true;
                    return;
                }

                if ($feature('creditInstallmentOffers') && $scope.checkoutSession.get('plan.paypal_credit') && $scope.installment.showCYCO && $scope.creditOptions && !$scope.creditOptions.creditType) {
                    return $state.go('checkout.chooseCreditOffer');
                }
                // Address Normalization Checks
                if ($scope.checkoutAppData.get('flags.allow_change_shipping', false) && $feature('shippingAddressNormalization') && $scope.checkoutSession.get('shipping.normalization_status') === 'UNKNOWN') {

                    return $state.go('checkout.review.sidebar.updateShipping');
                }

                /* Call patchCvv first, if error, need buyers to input again */
                /* Call to set Sticky Funding Instrument for Billing Agreement.
                 *  We have to ensure the sticky call happens before authorize due to symphony spec.*/
                /* We need to wait for the response from updateAddressAsPreferred before calling authorize */

                $fiApis.patchCvv($scope.checkoutSession).then(function () {
                    return $q.all([setStickyInstrument(), updateAddressAsPreferred(), updateEmailBuyerOptin($scope.checkoutAppData, $scope.optin.email)])['catch'](function (err) {
                        // should we have more elaborate error handling here?
                        $logger.error('onPay() error', err);
                    })['finally'](function () {
                        return authorize();
                    });
                }, function (err) {
                    $logger.error('onPay() patchCvv error', err);
                });
            };

            /* This is used for a BML 'popup' that opens covering the whole review page,
             hiding the rest of the review page when its open. */
            $scope.bmlPopupOpen = false;

            $scope.showBmlPopup = function () {
                $scope.bmlPopupOpen = true;
            };

            $scope.hideBmlPopup = function () {
                $scope.bmlPopupOpen = false;
            };
        });
        (0, _jquery2['default'])('.paypalHeaderWrapper').removeClass('paypalCredit');
        (0, _jquery2['default'])('.paypalHeaderWrapper').removeClass('paypalCreditTnc');

        $scope.onComplete = function () {
            $state.go('checkout.review');
        };
    }
});

angular.value("$xoReviewPageComponent", $xoReviewPageComponent);
_squid.$Component;

_squid.formatNameInformal;


/*****************
 ** WEBPACK FOOTER
 ** ./pages/xo-review/directive.js
 ** module id = 359
 ** module chunks = 1
 **/